import {SectionHeader} from "app/components/sectionHeader";
import * as React from "react";
import {useBranding} from "./useBranding";
import {PlusIcon} from "@heroicons/react/24/outline";
import {CheckCircleIcon} from "@heroicons/react/24/solid";
import {Spinner} from "@nextui-org/react";
import {Store} from "lucide-react";

export interface BrandingProps {
}

export const Branding: React.FC<BrandingProps> = (props) => {
    const {
        handleLogoChange,
        handleLandingImageChange,
        saveSelectedImage,
        logoPreview,
        landingImagesPreview,
        account,
        handleLogoUpload,
        logoUploading,
        removeLogo,
        landingImageUploading,
        setLandingImageUploading,
        removeLandingImage
    } = useBranding();


    return (
        <div className="flex flex-col w-full gap-6">

            <div>
                <h4 className="text-base font-medium text-gray-900 mb-4">Business Logo</h4>
                <div className="flex items-center space-x-6">
                    <div
                        className="w-24 h-24 bg-gray-100 rounded-lg border-2 border-dashed border-gray-300 flex items-center justify-center">
                        <div className="text-center">


                            {logoPreview ? (
                                    <div className="relative h-[100px] w-[100px]">
                                        {logoUploading && (
                                            <span
                                                className="absolute inset-0 flex items-center justify-center bg-white/50 rounded">
                <Spinner/>
            </span>
                                        )}
                                        <img
                                            src={logoPreview}
                                            alt="Logo Preview"
                                            className="h-full w-full rounded border object-cover"
                                        />
                                    </div>
                                ) :
                                <div className="relative h-[100px] w-[100px] flex justify-center items-center">
                                    <div className={'text-center'}>
                                        <Store className="w-8 h-8 mx-auto text-gray-400 mb-2"/>
                                        <p className="text-xs text-gray-500">No Logo</p>
                                    </div>

                                </div>
                            }


                        </div>
                    </div>


                    <div className="flex-1">
                        <div className="flex items-center space-x-4">
                            <label
                                className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 cursor-pointer flex items-center space-x-2">
                                <input disabled={logoUploading} id="logo-upload" onChange={handleLogoChange} type="file"
                                       accept="image/*"
                                       className="hidden"/>
                                <span>Upload Logo</span>
                            </label>
                            {account?.logo && <button onClick={removeLogo}
                                                      className="text-red-600 hover:text-red-700 text-sm font-medium">
                                Remove Logo
                            </button>}
                        </div>
                        <p className="text-xs text-gray-500 mt-2">
                            Recommended: Square image, at least 200x200px, PNG or JPG format
                        </p>
                    </div>
                </div>
            </div>


            <div>
                <h4 className="text-base font-medium text-gray-900 mb-4">Business Landing Image</h4>
                <p className="text-sm py-2">
                    This will be displayed on your booking page. Upload your own or choose
                    one from our library. Accepted file types: .jpg and .png
                </p>
                <div className="flex items-center space-x-6">
                    <div
                        className="w-24 h-24 bg-gray-100 rounded-lg border-2 border-dashed border-gray-300 flex items-center justify-center">
                        <div className="text-center">


                            {landingImagesPreview ? (
                                    <div className="relative h-[100px] w-[100px]">
                                        {landingImageUploading && (
                                            <span
                                                className="absolute inset-0 flex items-center justify-center bg-white/50 rounded">
                <Spinner/>
            </span>
                                        )}
                                        <img
                                            src={landingImagesPreview}
                                            alt="Logo Preview"
                                            className="h-full w-full rounded border object-cover"
                                        />
                                    </div>
                                ) :
                                <div className="relative h-[100px] w-[100px] flex justify-center items-center">
                                    <div className={'text-center'}>
                                        <Store className="w̉-8 h-8 mx-auto text-gray-400 mb-2"/>
                                        <p className="text-xs text-gray-500">No Landing Image</p>
                                    </div>

                                </div>
                            }


                        </div>
                    </div>


                    <div className="flex-1">
                        <div className="flex items-center space-x-4">
                            <label
                                className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 cursor-pointer flex items-center space-x-2">
                                <input disabled={landingImageUploading} id="logo-upload"
                                       onChange={handleLandingImageChange} type="file" accept="image/*"
                                       className="hidden"/>
                                <span>Upload Landing Image</span>
                            </label>
                            {account?.selectedLandingImageLink && <button onClick={removeLandingImage}
                                                                          className="text-red-600 hover:text-red-700 text-sm font-medium">
                                Remove Landing Image
                            </button>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
